import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useEffect, useState } from "react";
import React from "react";
import { useLayoutEffect } from "react";
import Slider from "react-slick";
import "./About.css";
import star from "./assets/star.png";
import ContactUs from "./ContactUs";
import Footer from "./Footer";

const ROOT_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000"
    : "https://ezice.herokuapp.com";

const CONTENT = [
  [
    {
      category: "About",
      title: null,
      content:
        "After years of building his family’s outdoor ice rink “the old-fashioned way,” inventor Dylan Gastel dreamed of an easier way to skate at home.\n\nIn 2016, he created the EZ ICE 60 Minute Backyard Rink®, the most convenient way to build an outdoor rink without all the hassle.\n\nSince then, EZ ICE’s revolutionary design has helped over 10,000 families – including many professional hockey players and coaches – experience the magic and memories that come with having a backyard ice rink.",
      video:
        "https://d1cadrokl7e9dp.cloudfront.net/home/Reel72_V4_COMPRESSED.mp4",
      videoMobile:
        "https://d1cadrokl7e9dp.cloudfront.net/home/Reel72_9x16_V5.mp4",
    },
  ],

  [
    {
      category: "The Rink of the Future",
      title: "The Rink of the Future",
      content:
        "EZ ICE proudly has warehouses in both the US and Canada to quickly serve customers in both countries.\n\nEZ ICE parts are meant to be reused year after year, and recycled when the time comes, to achieve a more sustainable backyard rink experience. ",
      video: "https://d1cadrokl7e9dp.cloudfront.net/home/Reel63_V4.mp4",
      videoMobile:
        "https://d1cadrokl7e9dp.cloudfront.net/home/Reel63_9x16_V2.mp4",
    },
  ],

  [
    {
      category: "Our Team",
      title: "Our Team",
      content:
        "We’re a group of hockey lovers, lifelong outdoor rink builders and expert engineers dedicated to one goal: providing you and your family with the most convenient and highest quality outdoor rink on the market. We know what your backyard rink means to you – we have them too.\n\nThe EZ ICE team takes pride in delivering world class customer service to each and every one of our customers. Whether you’re a first year builder or a seasoned pro, you can trust that our team is here to support you.",
      image:
        "https://d1cadrokl7e9dp.cloudfront.net/home/Employee Collage 169.png",
      imageMobile:
        "https://d1cadrokl7e9dp.cloudfront.net/home/Employee Collage (9 x 16 in) (1).webp",
    },
  ],
];

const REVIEWS = [
  {
    review:
      "First year builder, single mom from Rochester, NY. My birthday gift was getting to enjoy a first mother and son skate on our rink this weekend. Thank you from the bottom of my heart for making your rink kits user friendly.",
    firstName: "Amy",
    location: "New York",
    imageFile: "700 AMY NEW YORK.png",
  },
  {
    review:
      "Our kids had never skated before and we took a chance. It’s the best family Christmas present ever according to the kids. They went from using a pusher to racing around the 30’x60’ rink under the lights with no assistance.",
    firstName: "Lisa",
    location: "Maine",
    imageFile: "700. LISA MAINE.png",
  },
  {
    review:
      "With Boys aged 5 and 13, we have a lot of use of our EZ ICE Rink. It’s hosted birthday parties and is the ‘go to’ place for our boys team to gather. We love that they can skate any time they want, and love the ease of storage in the summer and set up in the fall.",
    firstName: "Tiffany",
    location: "Manitoba",
    imageFile: "700 TIFFANY MANITOBA.png",
  },
  {
    review:
      "The puck plays off the board more than it does with wood. The action is closer to what you get on a real rink.",
    firstName: "Henry",
    location: "New York",
    imageFile: "700 HENRY NY.png",
  },
  {
    review:
      "Quickest set up and take down in the business! I can't wait for winter simply because of this rink!",
    firstName: "Peter",
    location: "Alberta",
    imageFile: "700 PETER AB.png",
  },
  {
    review:
      "We love everything about the rink. Easy set up, easy to store, and very durable.",
    firstName: "Christie",
    location: "Ontario",
    imageFile: "700 CHRISTIE ON.png",
  },
  {
    review:
      "100% satisfied and have recommended to all our friends and family, and plan on expanding the size next year!",
    firstName: "John",
    location: "Alaska",
    imageFile: "700 JOHN AK.png",
  },
  {
    review:
      "We are having a great year with our ice rink. My youngest son skates everyday.",
    firstName: "Phil",
    location: "Illinois",
    imageFile: "700 PHIL IL.png",
  },
  {
    review:
      "All the extra ice time at home really helped them have incredible seasons.",
    firstName: "Meredith",
    location: "New Hampshire",
    imageFile: "700 MEREDITH NH.png",
  },
  {
    review:
      "We absolutely love our EZ ICE Rink. All 3 of our kids use it a bunch. They have a blast! My son’s hands and confidence have really improved over this winter and it has really come through on his team. It’s been great fun and a total success.",
    firstName: "Todd",
    location: "Michigan",
    imageFile: "700 TODD MI.png",
  },
  {
    review:
      "We love our rink and having friends and family over to skate! It’s even motivated some friends to go out and buy their first pair of ice skates!",
    firstName: "Tyler",
    location: "Illinois",
    imageFile: "700 TYLER IL.png",
  },
  {
    review:
      "We absolutely love the rink and it was truly the easiest thing to put up!",
    firstName: "Betsy",
    location: "Illinois",
    imageFile: "700 BETSY IL.png",
  },
  {
    review:
      "The entire neighborhood loves our EZ ICE Rink. We had 6 boys playing hockey for 4 hours yesterday!",
    firstName: "Joanna",
    location: "Massachusetts",
    imageFile: "700 JOANNA MA.png",
  },
  {
    review:
      "EZ ICE synthetic ice is the perfect solution for my son. The extra-large size of the squares means fewer seams and a more fluid stick handling experience. This definitely sets them apart from the competition. If you are looking for a way to get some more ice time without the ice, this is the perfect product for you.",
    firstName: "Andrea",
    location: "Texas",
    imageFile: "700 ANDREA TX.png",
  },
  {
    review:
      "What we like most about your product is that we can still use it this year since our Minnesota ground is frozen.",
    firstName: "Troy",
    location: "Minnesota",
    imageFile: "700 TROY MN.png",
  },
  {
    review:
      "Our new community EZ ICE Rink was an incredible hit it's first winter! Residents in town can't wait to get back out on the ice again this year - for once people are actually wishing for colder weather.",
    firstName: "Callie",
    location: "Iowa",
    imageFile: "700 WABIGOON.png",
  },
  {
    review:
      "ODR season came quick with a cold front coming through fast. Thankfully EZ ICE Rinks are simple set ups and we were able to get the liner dropped and the hose running the same day.",
    firstName: "Matthew",
    location: "Pennsylvania",
    imageFile: "700 MATTHEW PA.png",
  },
  {
    review:
      "It seriously took my husband an hour to do this year by himself one night! It is such a simple solution and truly an EZ Rink to put together! Our kids will get endless hours of ice time now and only get stronger as skaters.",
    firstName: "Jennie",
    location: "Minnesota",
    imageFile: "700 JENNIE MN.png",
  },
  {
    review:
      "My son rocked it in his hockey game - scored 4 goals from being able to practice at home. The results are amazing.",
    firstName: "Richard",
    location: "Massachusetts",
    imageFile: "700 RICHARD MA.png",
  },
  {
    review:
      "As an ice rink novice I fully expected this would be somewhat challenging to assemble, but I couldn't be more wrong. My 8 and 6 year old boys and I had it up in under an hour. It was so easy!",
    firstName: "Matthew",
    location: "New York",
    imageFile: "700 MATTHEW NY.png",
  },
  {
    review:
      "We love our EZ ICE! Best way to stay on top of our hockey skills & have fun with our family.",
    firstName: "Wendy",
    location: "Alberta",
    imageFile: "700 WENDY AB.png",
  },
  {
    review:
      "It was SO easy for these grandparents and grandchildren to put together. 20 minutes!",
    firstName: "Terry",
    location: "New Hampshire",
    imageFile: "700 TERRY NH.png",
  },
  {
    review:
      "Each night after school my daughter comes home and gets an hour on her EZ ICE RINK. Her coach has commented that her stick handling has improved as a result. The ability to have her own small area to just play by herself is awesome.",
    firstName: "Paul",
    location: "New Jersey",
    imageFile: "700 PAUL NJ.png",
  },
  {
    review:
      "I'd like to thank you guys for making a product that makes memories I hope my sons will remember for the rest of their lives. Because I will remember them for as long as I live.",
    firstName: "Steven",
    location: "Illinois",
    imageFile: "700 STEVEN IL.png",
  },
  {
    review:
      "EZ ICE synthetic ice has been the perfect way for my son to continue improving his hockey skills.",
    firstName: "Andrea",
    location: "Texas",
    imageFile: "700 ANDREA TX (1).png",
  },
];

const NEWS = [
  {
    newsOutlet: "The Boston Globe",
    linkText:
      "Newton company’s rink brings ice hockey to backyards across North America",
    link: "https://www.bostonglobe.com/2021/12/10/business/newton-companys-rink-brings-ice-hockey-backyards-across-north-america/",
    imageUrl:
      "//ezicerinks.com/cdn/shop/files/Boston_Globe_480x480_0b94a946-f2fc-4687-b52a-62faba018ddf.jpg?v=1666395965&amp;width=2048",
  },
  {
    newsOutlet: "Forbes",
    linkText:
      "EZ ICE Inventor & CEO Dylan Gastel - 2021 Forbes 30 Under 30 | Manufacturing & Industry",
    link: "https://www.forbes.com/profile/dylan-gastel/?sh=39182d3e34f0",
    imageUrl:
      "//ezicerinks.com/cdn/shop/files/forbes_png.png?v=1666396084&amp;width=2048",
  },
  {
    newsOutlet: "Business Insider",
    linkText:
      "How a 25-year-old entrepreneur made $16 million in revenue last year selling backyard ice rinks",
    link: "https://www.businessinsider.com/25-year-old-entrepreneur-16-million-selling-backyard-ice-rinks-2021-11",
    imageUrl:
      "//ezicerinks.com/cdn/shop/files/Business_Insider_480x480_8ee23922-0d1e-4c0a-9a6f-204ea6985816.webp?v=1666396299&amp;width=2048",
  },
  {
    newsOutlet: "CBS News",
    linkText:
      "Brilliant method for building DIY backyard rinks gets an upgrade",
    link: "https://www.cbsnews.com/boston/news/backyard-ez-ice-rink-business-booming-dylan-gastel-newton/",
    imageUrl:
      "//ezicerinks.com/cdn/shop/files/Screen_Shot_2022-10-21_at_7.50.10_PM.png?v=1666396227&amp;width=2048",
  },
  {
    newsOutlet: "The New York Times",
    linkText: "With indoor rinks closed, players turn to ‘Speakeasy Hockey’",
    link: "https://www.nytimes.com/2021/02/15/sports/hockey/rinks-pandemic-restrictions.html",
    imageUrl:
      "//ezicerinks.com/cdn/shop/files/NY_Times_480x480_0fb5bd76-1b54-4301-aa43-a9d41e084bf5.webp?v=1666396134&amp;width=2048",
  },
  {
    newsOutlet: "The Wall Street Journal",
    linkText:
      "Building an ice rink in your backyard? ‘Water and gravity will always win’",
    link: "https://www.wsj.com/articles/building-an-ice-rink-in-your-backyard-water-and-gravity-will-always-win-11613494552",
    imageUrl:
      "//ezicerinks.com/cdn/shop/files/WSJ-Logo_480x480_6e166786-aa25-4320-96de-65ff81b3801f.webp?v=1666395874&amp;width=2048",
  },
  {
    newsOutlet: "The Providence Journal",
    linkText:
      "Yale student from Lincoln turns backyard rinks into fast-growing business",
    link: "https://www.providencejournal.com/news/20180126/yale-student-from-lincoln-turns-backyard-rinks-into-fast-growing-business--video",
    imageUrl:
      "//ezicerinks.com/cdn/shop/files/providence-journal-1_480x480_adc05e41-fd4a-46b0-83e6-92159b176889.webp?v=1666396422&amp;width=2048",
  },
  {
    newsOutlet: "The Globe and Mail",
    linkText:
      "Bringing it home: Backyard rinks regain their sheen in times of Covid-19",
    link: "https://www.theglobeandmail.com/canada/article-bringing-it-home-backyard-rinks-regain-their-sheen-in-times-of-covid/",
    imageUrl:
      "//ezicerinks.com/cdn/shop/files/globe_and_mail_logo.png?v=1666396475&amp;width=2048",
  },
];

function About(props) {
  const [row0Idx, setRow0Idx] = useState(0);
  const [row1Idx, setRow1Idx] = useState(0);
  const [row2Idx, setRow2Idx] = useState(0);
  const [row3Idx, setRow3Idx] = useState(0);
  const [row4Idx, setRow4Idx] = useState(0);

  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
  };

  function toggleSlide(row, direction) {
    eval("setRow" + row + "Idx")(
      (eval("row" + row + "Idx") + direction + CONTENT[row].length) %
        CONTENT[row].length
    );
  }

  const shuffledReviews = REVIEWS.sort(() => Math.random() - 0.5);

  useLayoutEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, []);

  return (
    <>
      <div
        className="flex my-8 text-black align-center justify-center text-3xl font-bold"
        id="ezice"
      >
        About EZ ICE
      </div>

      {CONTENT.map((row, rowIdx) => {
        return (
          <div className="flex w-full bk6:flex-col learn-more-container">
            <div
              className={`w-1/5 bk6:w-full bk6:ml-0 bk6:mr-0 relative bg-gray-100 ${
                rowIdx % 2 === 0 ? "bk6m:ml-4" : "bk6m:mr-4"
              } ${
                rowIdx % 2 === 0 && window.innerWidth > 900
                  ? "order-2"
                  : "order-1"
              }`}
            >
              <div className="flex flex-col h-full px-4">
                <div className="content-container bk6m:mt-4 pt-4">
                  <h1 className="text-2xl font-bold">
                    {CONTENT[rowIdx][eval("row" + rowIdx + "Idx")].title}
                  </h1>
                  <p
                    className="mt-4 text-gray-500"
                    style={{ whiteSpace: "pre-line" }}
                  >
                    {CONTENT[rowIdx][eval("row" + rowIdx + "Idx")].content}
                  </p>
                </div>
              </div>
            </div>
            <div
              className={`w-4/5 bk6:w-full relative ${
                rowIdx % 2 === 0 && window.innerWidth > 900
                  ? "order-1"
                  : "order-2"
              }`}
            >
              {CONTENT[rowIdx][eval("row" + rowIdx + "Idx")].image && (
                <img
                  className={`home-bg-video bk6m:mb-4 w-full bg-contain object-cover border-solid border-b-2 border-white ${
                    rowIdx === 0 ? "h-[calc(100vh-108px)]" : "h-screen"
                  }`}
                  src={
                    window.innerWidth > 800
                      ? CONTENT[rowIdx][eval("row" + rowIdx + "Idx")].image
                      : CONTENT[rowIdx][eval("row" + rowIdx + "Idx")]
                          .imageMobile
                  }
                />
              )}

              {CONTENT[rowIdx][eval("row" + rowIdx + "Idx")].video && (
                <video
                  className={`home-bg-video bk6m:mb-4 w-full bg-contain object-cover border-solid border-b-2 border-white ${
                    rowIdx === 0 ? "h-[calc(100vh-108px)]" : "h-screen"
                  }`}
                  loop
                  muted
                  autoPlay
                  playsInline
                  preload="none"
                  key={CONTENT[rowIdx][eval("row" + rowIdx + "Idx")].video}
                >
                  <source
                    src={
                      window.innerWidth > 800
                        ? CONTENT[rowIdx][eval("row" + rowIdx + "Idx")].video
                        : CONTENT[rowIdx][eval("row" + rowIdx + "Idx")]
                            .videoMobile
                    }
                    type="video/mp4"
                  ></source>
                </video>
              )}
            </div>
          </div>
        );
      })}
      <section className="relative image-slider-container" id="testimonials">
        <div className="flex my-8 text-black align-center justify-center text-3xl font-bold">
          Customer Testimonials
        </div>
        <div className="flex flex-col h-[calc(100%-108px)] justify-center px-8">
          <Slider {...settings}>
            {shuffledReviews.map((review, index) => (
              <div className="flex justify-center items-center justify-center px-8 bk5:px-2">
                <div
                  key={index}
                  className="flex bk6:flex-col bk6:items-center max-w-[1500px]"
                >
                  <div className="w-[50%] bk6:w-full">
                    <img
                      className="object-cover w-full h-full rounded-tl-3xl rounded-bl-3xl bk6:rounded-tr-3xl bk6:rounded-bl-none"
                      src={
                        "https://d1cadrokl7e9dp.cloudfront.net/home/" +
                        review.imageFile
                      }
                    />
                  </div>
                  <div className="w-[50%] bk6:w-full pl-8 pr-8 py-4 flex flex-col justify-center bg-gray-300 rounded-tr-3xl rounded-br-3xl bk6:rounded-bl-3xl bk6:rounded-tr-none">
                    <div className="flex justify-center mb-4">
                      <img className="h-8 w-8 mr-1" src={star} />
                      <img className="h-8 w-8 mr-1" src={star} />
                      <img className="h-8 w-8 mr-1" src={star} />
                      <img className="h-8 w-8 mr-1" src={star} />
                      <img className="h-8 w-8" src={star} />
                    </div>
                    <div className="mb-4 text-lg bk5:text-sm">
                      {review.review}
                    </div>
                    <div className="">
                      -{review.firstName}, {review.location}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
          <div className="flex justify-center w-full">
            <li className="ml-3 text-gray-400"></li>
            <li className="ml-2 text-gray-400"></li>
            <li className="ml-2 text-gray-400"></li>
            <li className="ml-2 text-gray-400"></li>
            <li className="ml-2 text-gray-400"></li>
          </div>
        </div>
      </section>
      <section className="mt-20 mb-12" id="news">
        <div className="flex flex-col justify-center w-full">
          <div className="flex mb-4 text-black align-center justify-center text-3xl font-bold w-full">
            EZ ICE In the News
          </div>
          <div className="flex w-full justify-center items-center">
            <div className="flex flex-wrap w-[1600px]">
              {NEWS.map((news, index) => (
                <div className="flex w-1/2 p-4">
                  <div className="flex align-center items-center justify-center">
                    <a
                      href={news.link}
                      className=""
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img className="w-24" src={news.imageUrl} />
                    </a>
                  </div>
                  <div className="flex flex-col align-center ml-8 justify-center">
                    <div className="font-bold mb-1">{news.newsOutlet}</div>
                    <a
                      href={news.link}
                      className="text-xs"
                      target="_blank"
                      rel="noreferrer"
                    >
                      {news.linkText}
                    </a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default About;
